import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Prompt } from 'react-router-dom';
import NoSavingStrategyPopup from '../Popup/NoSavingStrategyPopup';
import { setUnsavedChanges } from '../../redux/actions/Team';

export const RouteLeavingGuard = ({
  navigate,
  when,
  shouldBlockNavigation,
  yes,
  no,
  content,
  saveStrategyCb,
  saveError,
  setSaveError,
}) => {
  const [modalVisible, updateModalVisible] = useState(false);
  const [lastLocation, updateLastLocation] = useState();
  const [confirmedNavigation, updateConfirmedNavigation] = useState(false);
  const dispatch = useDispatch();
  const showModal = (location) => {
    updateModalVisible(true);
    updateLastLocation(location);
  };

  const closeModal = (cb) => {
    updateModalVisible(false);
    if (cb) {
      cb();
    } else {
      saveStrategyCb();
    }
  };

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
      showModal(nextLocation);
      return false;
    }
    return true;
  };
  const handleConfirmNavigationClick = () => {
    updateModalVisible(false);
    closeModal(() => {
      if (lastLocation) {
        updateConfirmedNavigation(true);
        navigate(lastLocation.pathname);
      }
    });
  };

  useEffect(() => {
    if (confirmedNavigation) {
      navigate(lastLocation.pathname);
      updateConfirmedNavigation(false);
    }
    return () => {
      dispatch(setUnsavedChanges(false));
      setSaveError(false);
    };
  }, [confirmedNavigation, saveError]);

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <NoSavingStrategyPopup
        yes={yes}
        no={no}
        visible={modalVisible}
        onCancel={closeModal}
        onConfirm={handleConfirmNavigationClick}
        content={content}
      />
    </>
  );
};

export default RouteLeavingGuard;
